import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { OxygenActionV2 } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-oxygen-slot-v2',
    templateUrl: './oxygen-slot-v2.component.html',
    styleUrl: './oxygen-slot-v2.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OxygenSlotComponentV2 implements SheetSlotComponentBase {

	action!: OxygenActionV2;
	value!: string | null;

	@Input('action') set updateAction(action: OxygenActionV2 | null) {
		this.action = action as OxygenActionV2;
		this.value = this.action.percentageGiven?.value?.toString() ?? null;
	}

	constructor() {
	}
}